import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useServiceRecordWizardDraftOptional } from '../contexts/ServiceRecordWizardDraftContext';

const SkGeciciTaslakHeaderMenu = () => {
  const navigate = useNavigate();
  const draftCtx = useServiceRecordWizardDraftOptional();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const hasDraft = draftCtx?.hasDraft?.() ?? false;
  const summary = draftCtx?.getDraftSummary?.() ?? null;

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const handleDevam = useCallback(() => {
    if (!draftCtx?.markRestorePending) return;
    draftCtx.markRestorePending();
    setOpen(false);
    navigate('/service-records/create', { state: { restoreGeciciTaslak: true } });
  }, [draftCtx, navigate]);

  const handleSil = useCallback(() => {
    if (!window.confirm('Geçici taslak silinsin mi?')) return;
    draftCtx?.clearDraft?.();
    setOpen(false);
  }, [draftCtx]);

  if (!hasDraft) return null;

  return (
    <div className="top-header-sk-taslak" ref={wrapRef}>
      <button
        type="button"
        className={`top-header-sk-taslak-btn${open ? ' top-header-sk-taslak-btn--open' : ''}`}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        title="Geçici servis kaydı taslağı"
      >
        <i className="fas fa-file-alt" aria-hidden />
        <span style={{ maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {summary?.musteriAdi || 'Taslak'}
        </span>
      </button>
      {open ? (
        <div className="top-header-sk-taslak-menu" role="menu">
          <div className="top-header-sk-taslak-menu__meta">
            Geçici taslak
            {summary?.isSantral ? ' · Santral' : ''}
            {summary?.adim ? ` · ${summary.adim}` : ''}
          </div>
          <button type="button" className="top-header-sk-taslak-menu__item" role="menuitem" onClick={handleDevam}>
            <i className="fas fa-play" aria-hidden /> Devam et
          </button>
          <button
            type="button"
            className="top-header-sk-taslak-menu__item top-header-sk-taslak-menu__item--danger"
            role="menuitem"
            onClick={handleSil}
          >
            <i className="fas fa-trash-alt" aria-hidden /> Sil
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default SkGeciciTaslakHeaderMenu;
